import { Skeleton } from 'antd'
import Styles from './LoadingProfile.module.scss'

const Section = () => (
  <>
    <section className={Styles.section}>
      <Skeleton
        active
        title={{ width: '60%', style: { height: '30px', borderRadius: '29px', margin: 0, padding: 0 } }}
        paragraph={false}
        avatar={false}
      />
    </section>
    <section className={Styles.section}>
      <Skeleton
        active
        title={{ width: '45%', style: { height: '17px', borderRadius: '29px', margin: 0, padding: 0 } }}
        paragraph={false}
        avatar={false}
      />
      <Skeleton
        active
        title={{ width: '30%', style: { height: '17px', borderRadius: '29px', margin: 0, padding: 0 } }}
        paragraph={false}
        avatar={false}
      />
      <Skeleton
        active
        title={{ width: '20%', style: { height: '17px', borderRadius: '29px', margin: 0, padding: 0 } }}
        paragraph={false}
        avatar={false}
      />
      <div className={Styles.section}>
        <Skeleton
          active
          title={{ width: '100%', style: { height: '17px', borderRadius: '29px', margin: 0, padding: 0 } }}
          paragraph={false}
          avatar={false}
        />
        <Skeleton
          active
          title={{ width: '90%', style: { height: '17px', borderRadius: '29px', margin: 0, padding: 0 } }}
          paragraph={false}
          avatar={false}
        />
      </div>
    </section>
  </>
)

export const LoadingProfile = ({ sections = 3 }: { sections?: number }) => {
  return (
    <>
      <section className={Styles.section}>
        <Skeleton
          active
          title={{ width: '30%', style: { height: '50px', borderRadius: '29px', margin: 0, padding: 0 } }}
          paragraph={false}
          avatar={false}
        />
      </section>
      {Array.from({ length: sections }).map((_, index) => (
        <Section key={index} />
      ))}
    </>
  )
}
